import { Color, formatBytes, Icon, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from '../../styles'

interface FecImportFileOutputProps {
  errorMessage?: string
  fileName: string
  fileSize?: number
  period?: string
}

export const FecImportFileOutput = ({
  errorMessage,
  fileName,
  fileSize,
  period,
}: FecImportFileOutputProps): ReactElement => {
  const hasError = !!errorMessage

  return (
    <Styled.FileItemGroup>
      <Styled.FileItem $hasError={hasError}>
        <Styled.FileIconWrapper>
          {hasError ? (
            <Icon aria-hidden="true" color={Color.Red700} icon="fileXCorner" size="md" />
          ) : (
            <Styled.SuccessSquircle>
              <Icon aria-hidden="true" color={Color.Lime800} icon="check" />
            </Styled.SuccessSquircle>
          )}
        </Styled.FileIconWrapper>
        <Styled.FileContent>
          <Text
            colorVariant="primary"
            title={fileName}
            truncate
            variant="bodyLG"
            weight={hasError ? 'semiBold' : 'medium'}
          >
            {fileName}
          </Text>
          {hasError
            ? fileSize !== undefined && (
                <Text colorVariant="primary" variant="bodySM">
                  {formatBytes(fileSize)}
                </Text>
              )
            : period && (
                <Text colorVariant="primary" variant="bodySM">
                  {period}
                </Text>
              )}
        </Styled.FileContent>
      </Styled.FileItem>
      {errorMessage && (
        <Text colorVariant="danger" role="alert" variant="bodySM">
          {errorMessage}
        </Text>
      )}
    </Styled.FileItemGroup>
  )
}
